import { domToReact } from "html-react-parser"
import React from "react"

export const sectionTitleOptions = {
  replace: element => {
    const { name, children } = element
    if (name === "h2") {
      return (
        <h2 className="text-3xl font-bold leading-normal text-charlestonGreen-500  lg:text-4xl">
          {domToReact(children, sectionTitleOptions)}
        </h2>
      )
    }

    if (name === "strong") {
      return (
        <span className="text-blue-400">
          {domToReact(children, sectionTitleOptions)}
        </span>
      )
    }
    return null
  },
}

export const brightSectionTitle = {
  replace: element => {
    const { name, children } = element
    if (name === "h2") {
      return (
        <h2 className="text-3xl font-bold leading-normal text-white lg:text-5xl">
          {domToReact(children, brightSectionTitle)}
        </h2>
      )
    }
    if (name === "strong") {
      return (
        <span className="text-orangeSafe">
          {domToReact(children, brightSectionTitle)}
        </span>
      )
    }
    return null
  },
}
